export const getWrappedTitle = (title: string, parentTitle: string) => {
  return title ? `${title} - ${parentTitle}` : `${parentTitle}`;
}

export const setTitleForClient = (title: string, parentTitle: string) => {
  document.title = getWrappedTitle(title, parentTitle);
}
